<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="text-h6">
                <v-icon left color="primary">mdi-calendar-clock</v-icon>
                Turno assegnato
                <v-spacer></v-spacer>
                <v-btn icon @click="load" :loading="loading">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-alert v-if="currentShift" type="success" dense text>
                    Turno corrente: <strong>{{ currentShift.template_name }}</strong>
                    dal {{ formatDate(currentShift.valid_from) }}
                    <span v-if="currentShift.valid_to">al {{ formatDate(currentShift.valid_to) }}</span>
                    <span v-else>(in corso)</span>
                </v-alert>
                <v-alert v-else type="warning" dense text>
                    Nessun turno assegnato. Le timbrature non avranno tolleranze ne' compilazione automatica del cartellino.
                </v-alert>

                <v-row dense class="mt-2">
                    <v-col cols="12" md="4">
                        <v-autocomplete
                            v-model="form.shift_template_id"
                            :items="shiftTemplates"
                            item-text="text"
                            item-value="value"
                            label="Template turno"
                            prepend-icon="mdi-calendar-clock"
                            outlined
                            dense
                            hide-details
                            clearable
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                        <gmh-date-picker
                            v-model="form.valid_from"
                            label="Valido dal"
                            prepend-icon="mdi-calendar-start"
                            hide-details
                            editable
                        ></gmh-date-picker>
                    </v-col>
                    <v-col cols="12" md="3">
                        <gmh-date-picker
                            v-model="form.valid_to"
                            label="Valido fino al (opz.)"
                            prepend-icon="mdi-calendar-end"
                            hide-details
                            editable
                        ></gmh-date-picker>
                    </v-col>
                    <v-col cols="12" md="2" class="d-flex align-center justify-end">
                        <v-btn color="primary" block :loading="saving" :disabled="!form.shift_template_id || !form.valid_from" @click="assign">
                            <v-icon left small>mdi-check</v-icon>
                            Assegna
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <v-card class="mt-4" v-if="history.length">
            <v-card-title class="text-subtitle-1">Storico turni</v-card-title>
            <v-data-table
                :headers="headers"
                :items="history"
                :items-per-page="20"
                dense>
                <template v-slot:item.valid_from="{ item }">{{ formatDate(item.valid_from) }}</template>
                <template v-slot:item.valid_to="{ item }">{{ item.valid_to ? formatDate(item.valid_to) : '—' }}</template>
                <template v-slot:item.template_name="{ item }">
                    <v-chip x-small color="indigo" text-color="white">{{ item.template_name }}</v-chip>
                </template>
            </v-data-table>
        </v-card>
    </v-container>
</template>

<script>
import { localDateStr } from '@/components/utilities/hrDates'
    export default {
        name: 'hr-employee-shift',
        props: { id: Number },

        data() {
            return {
                history: [],
                shiftTemplates: [],
                loading: false,
                saving: false,
                form: {
                    shift_template_id: null,
                    valid_from: localDateStr(),
                    valid_to: '',
                },
                headers: [
                    { text: 'Turno', value: 'template_name' },
                    { text: 'Dal', value: 'valid_from' },
                    { text: 'Al', value: 'valid_to' },
                ],
            }
        },

        computed: {
            currentShift() {
                const today = localDateStr()
                return this.history.find(h => h.valid_from <= today && (!h.valid_to || h.valid_to >= today)) || null
            },
        },

        methods: {
            load() {
                this.loading = true
                Promise.all([
                    this.axios.get(`hremployees/${this.id}/shifts`),
                    this.axios.post('hrshifttemplates-filters'),
                ]).then(([shiftsRes, templatesRes]) => {
                    this.history = shiftsRes.data.data || []
                    const tdata = templatesRes.data.data && templatesRes.data.data.data ? templatesRes.data.data.data : (Array.isArray(templatesRes.data.data) ? templatesRes.data.data : [])
                    this.shiftTemplates = tdata.filter(t => t.active !== false).map(t => ({ value: t.id, text: t.name }))
                    this.loading = false
                }, () => { this.loading = false })
            },
            assign() {
                this.saving = true
                this.axios.post(`hremployees/${this.id}/shifts`, {
                    shift_template_id: this.form.shift_template_id,
                    valid_from: this.form.valid_from,
                    valid_to: this.form.valid_to || null,
                }).then(() => {
                    this.saving = false
                    this.form.shift_template_id = null
                    this.form.valid_to = ''
                    this.load()
                }, () => { this.saving = false })
            },
            formatDate(d) { return d ? new Date(d).toLocaleDateString('it-IT') : '—' },
        },

        created() {
            this.$store.commit('endProgress')
            this.load()
        },
    }
</script>
